import React, { useMemo } from 'react';
import { detectTimeZone, listTimeZones, offsetLabel } from './eventsPublic';

const SELECT_CLASS =
    "border border-black bg-[#F8F9FA] px-1 py-[2px] text-[11px] tracking-wide text-gray-800 shadow-[0_2px_3px_rgba(6,19,25,0.25)] focus:outline-none";

const BUTTON_CLASS =
    "border border-black bg-[#F8F9FA] px-2 py-[2px] font-['Jersey_10'] text-[13px] uppercase leading-none tracking-[1px] text-gray-700 shadow-[0_2px_3px_rgba(6,19,25,0.25)] transition-colors hover:bg-gold";

function ZonePicker({ zone, onChange, variant = 'header', className = '' }) {
    const zones = useMemo(() => listTimeZones(), []);
    const localZone = useMemo(() => detectTimeZone(), []);

    const options = useMemo(
        () => (zones.includes(zone) ? zones : [zone, ...zones]),
        [zones, zone]
    );

    const isHeader = variant === 'header';

    return (
        <div className={`flex items-center gap-1 ${className}`}>
            <span
                className={
                    isHeader
                        ? "hidden font-['Jersey_10'] text-[15px] uppercase leading-none tracking-[1px] text-white sm:inline [text-shadow:-1px_0_0_#000,1px_0_0_#000,0_-1px_0_#000,0_1px_0_#000]"
                        : "font-['Jersey_10'] text-[15px] uppercase leading-none tracking-[1px] text-gray-600"
                }
            >
                Times in
            </span>

            <select
                value={zone}
                onChange={(event) => onChange(event.target.value)}
                aria-label="Choose the timezone events are shown in"
                className={`${SELECT_CLASS} max-w-[190px]`}
            >
                {options.map(entry => (
                    <option key={entry} value={entry}>
                        {entry.replace(/_/g, ' ')} ({offsetLabel(entry)})
                    </option>
                ))}
            </select>

            {zone !== localZone && (
                <button type="button" onClick={() => onChange(localZone)} className={BUTTON_CLASS} title={localZone}>
                    My time
                </button>
            )}

            {zone !== 'UTC' && (
                <button type="button" onClick={() => onChange('UTC')} className={BUTTON_CLASS}>
                    UTC
                </button>
            )}
        </div>
    );
}

export default ZonePicker;
